import { InputData } from "./InputData";

export class EmptyInput extends InputData
{

}